export default __webpack_public_path__ + "static/media/factory_dy0a.cb448bc7.svg";